import { ComponentChildren, h } from 'preact'

interface WeekProps {
  children: ComponentChildren
  key?: number
}

export const Week = ({ children, key }: WeekProps) => (
  <div className='a-week' key={key}>{children}</div>
)

export const Weekdays = () => {
  const weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
  return (
    <div className='m-weekdays'>
      {weekdays.map((week, idx) => <Week key={idx}>{week}</Week>)}
    </div>
  )
}
